import { styled } from "@mui/system";
import { Box, Typography } from "@mui/material";
import { Form } from "formik";

import { ArrayRemoveButton } from "../../../Buttons/ArrayRemoveButton";

export const FormContainer = styled(Form)(({ theme }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      background: "#fff"
    }
  },
  "& .MuiInputAdornment-root": {
    zIndex: 10
  },
  "& .MuiOutlinedInput-input": {
    zIndex: 10,
    margin: "2px"
  },
  "& textarea": {
    zIndex: 10
  },
  "& .MuiGrid-root": {
    "&> .MuiGrid-item": {
      paddingTop: "24px"
    }
  }

}));

export const Title = styled("div")(({ theme }) => ({
  fontSize: "16px"
}));

export const GroupLabel = styled("h4")(({ theme }) => ({
  marginTop: "15px",
  marginBottom: "7px",
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1.9",
  color: "#373737"
}));

export const FlexContainer = styled(Box)(({ theme }) => ({
  marginTop: "0",
  marginBottom: "0"
}));

export const StyledDivider = styled("div")(({ theme }) => ({
  marginTop: "30px",
  borderBottom: "solid 1px rgba(230, 230, 230, 0.5)"
}));

export const ControlsWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  margin: "20px 0 0"
}));

export const RelativeBox = styled(Box)(({ theme }) => ({
  position: "relative",
  marginBottom: "20px"
}));

export const TabletBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    marginBottom: "20px"
  }
}));

export const ButtonWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  margin: "40px 0"
}));

export const InfoTextWrapper = styled(Typography)(({ theme }) => ({
  marginBottom: "10px",
  color: "#86868b",
  marginLeft: 10
}));

export const AdornmentStyle = styled("span")(({ theme }) => ({
  zIndex: 1
}));

export const DeleteButton = styled(ArrayRemoveButton)(({ theme }) => ({
  marginRight: "20px",
  padding: "5px 10px",
  borderRadius: "20px",
  "& span": {
    textDecoration: "none"
  }
}));

export const AddButton = styled("div")(({ theme }) => ({
  marginRight: "20px",
  padding: "5px 10px",
  borderRadius: "20px",
  "& span": {
    textDecoration: "none"
  }
}));
